/**
 * 核心
 * vue/vue-router
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/vuex/index'

Vue.use(VueRouter) // 调用
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err)
}

/**
 * 引入路由表
 */

import account from './modules/account'
import index from './modules/index'
import paymentRecord from './modules/paymentRecord'

import settlement from './modules/settlement'
import riskManagement from './modules/riskManagement'
import logisticsManage from './modules/logisticsManage'
import homePage from './modules/homePage'
import system from './modules/system'
import defaultRouter from './defaultRouter/index'
import basicRouter from './basicRouter/index'
import paymentLink from './modules/paymentLink'
import transactionManagement from './modules/transactionManagement'
import notify from './modules/notify'

/**
 *
 * 配置路由
 * 即 页面 url 路由定义
 */

const permissionRouter = [
	...account,
	...index,
	...paymentRecord,
	...settlement,
	...logisticsManage,
	...homePage,
	...riskManagement,
	...system,
	...paymentLink,
	...transactionManagement,
	...notify
]

/**
 *  路由对象
 */

const router = new VueRouter({
	// 使用配置文件规则
	mode: 'history',
	routes: defaultRouter
})

/**
 * 路由钩子
 */

import afterEach from './hooks/afterEach'

const whiteList = [
	'/',
	'/#CP',
	'/#FAQ',
	'/aq/login',
	'/aq/setNewPwd',
	'/admin/whoisyourdaddy',
	'/aq/register',
	'/aq/account-create',
	'/aq/forgetPwd',
	'/aq/pp-auth',
	'/aq/selectWebsite',
	'/aq/set-trade-type',
	'/aq/faq',
	'/mobile/faq',
	'/mobile/faq/detail',
	'/aq/pay/demoStore',
	'/aq/contact'
]

router.beforeEach(async(to, from, next) => {
	const token = sessionStorage.getItem('accessToken')
	await store.dispatch('route/point', {
		to,
		from,
		next,
		router
	})
	if (whiteList.indexOf(to.path) !== -1) {
		next()
	} else {
		if (token) {
			const r = await store.dispatch('route/checkTradeType')
			if (!r.industryType) {
				next('/aq/set-trade-type')
			}
		} else {
			next()
		}
	}
})
router.afterEach(afterEach)
export {
	permissionRouter,
	defaultRouter,
	basicRouter
}
export default router
